import React, { useState } from 'react';
import { Select, Typography, Row, Col, Avatar, Card } from 'antd';
import moment from 'moment';
import { useGetCryptoNewsQuery } from '../services/cryptoNewsApi';
// imported now
import { useGetCryptosQuery } from '../services/cryptoApi';
import Loader from './Loader';

// const { Text, Title } = Typography;
// const { Option } = Select;
// const News = ({ simplified }) => {
//   const { data: cryptoNews } = useGetCryptoNewsQuery({
//     newsCategory: 'Cryptocurrency',
//     count: simplified ? 10 : 100,
//   });
//   console.log(cryptoNews);
//   return <div>News</div>;
// };

// to display the news now on the screen

// const { Text, Title } = Typography;
// const { Option } = Select;

// const demoImage =
//   'https://images.pexels.com/photos/6780789/pexels-photo-6780789.jpeg?auto=compress&cs=tinysrgb&w=100';

// const News = ({ simplified }) => {
//
//   const { data: cryptoNews } = useGetCryptoNewsQuery({
//     newsCategory: 'Cryptocurrency',
//     count: simplified ? 8 : 53,
//   });

//   if (!cryptoNews?.value) return 'Loading...';

//   return (
//     <Row gutter={[24, 24]}>
//      {cryptoNews.value.map((news, i) => (
//         <Col xs={24} sm={12} lg={8} key={i}>
//           <Card hoverable className='news-card'>
//             <a href={news.url} target='_blank' rel='noreferrer'>
//               <div className='news-image-container'>
//                 <Title className='news-title' level={4}>
//                   {news.name}
//                 </Title>
//                 {/* to show the images and || for those onces that dont have an images */}
//                 <img
//                   style={{ maxWidth: '200px', maxHeight: '100px' }}
//                   src={news?.image?.thumbnail?.contentUrl || demoImage}
//                   alt='news'
//                 />
//               </div>
//               <p>
//                 {news.description > 100
//                   ? `${news.description.substring(0, 100)}...`
//                   : news.description}
//               </p>
//               <div className='provider-container'>
//                 <div>
//                   <Avatar
//                     style={{ marginRight: '1rem' }}
//                     src={
//                       news.provider[0]?.image?.thumbnail?.contentUrl ||
//                       demoImage
//                     }
//                     alt=''
//                   />
//                   <Text className='provide-name'>{news.provider[0]?.name}</Text>
//                 </div>
//                 <Text>
//                   {moment(news.datePublished).startOf('ss').fromNow()}
//                 </Text>
//               </div>
//             </a>
//           </Card>
//         </Col>
//       ))}
//     </Row>
//   );
// };

// continued for the search button

const { Text, Title } = Typography;
const { Option } = Select;

const demoImage =
  'https://images.pexels.com/photos/6780789/pexels-photo-6780789.jpeg?auto=compress&cs=tinysrgb&w=100';

const News = ({ simplified }) => {
  const [newsCategory, setNewsCategory] = useState('Cryptocurrency');
  const { data: cryptoNews } = useGetCryptoNewsQuery({
    newsCategory,
    count: simplified ? 8 : 53,
  });
  const { data } = useGetCryptosQuery(100);

  if (!cryptoNews?.value) return <Loader />;

  return (
    <Row gutter={[24, 24]}>
      {!simplified && (
        <Col span={24}>
          <Select
            showSearch
            className='select-news'
            placeholder='Select a Crypto'
            optionFilterProp='children'
            onChange={(value) => setNewsCategory(value)}
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) > 0
            }
          >
            <Option value='Cryptocurrency'>Cryptocurrency</Option>
            {data?.data?.coins.map((coin) => (
              <Option value={coin.name}>{coin.name}</Option>
            ))}
          </Select>
        </Col>
      )}

      {cryptoNews.value.map((news, i) => (
        <Col xs={24} sm={12} lg={8} key={i}>
          <Card hoverable className='news-card'>
            <a href={news.url} target='_blank' rel='noreferrer'>
              <div className='news-image-container'>
                <Title className='news-title' level={4}>
                  {news.name}
                </Title>
                {/* to show the images and || for those onces that dont have an images */}
                <img
                  style={{ maxWidth: '200px', maxHeight: '100px' }}
                  className='image_news'
                  src={news?.image?.thumbnail?.contentUrl || demoImage}
                  alt='news'
                />
              </div>
              <p>
                {news.description > 100
                  ? `${news.description.substring(0, 100)}...`
                  : news.description}
              </p>
              <div className='provider-container'>
                <div>
                  <Avatar
                    style={{ marginRight: '1rem' }}
                    src={
                      news.provider[0]?.image?.thumbnail?.contentUrl ||
                      demoImage
                    }
                    alt=''
                  />
                  <Text className='provide-name'>{news.provider[0]?.name}</Text>
                </div>
                <Text>
                  {moment(news.datePublished).startOf('ss').fromNow()}
                </Text>
              </div>
            </a>
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default News;
